/* tslint:disable */
/* eslint-disable */
/**
 * Create Employee
 * API for creating employees with their data
 *
 * The version of the OpenAPI document: _
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmployeeRequest
 */
export interface CreateEmployeeRequest {
    /**
     * First name and last name.
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    fullName: string;
    /**
     * Email address of the employee
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    emailAddress: string;
    /**
     * Country code for phone number
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    countryCode: string;
    /**
     * the local part of the phone number, excluding the country code. Is always a Dutch number.
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    localPhoneNumber: string;
    /**
     * age of the employee
     * @type {number}
     * @memberof CreateEmployeeRequest
     */
    age: number;
    /**
     * dutch zipcode. May optionally have a space, letters lowercased or uppercased
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    placeOfResidence: string;
    /**
     * code of campaign
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    campaignCode: string;
}

export function CreateEmployeeRequestFromJSON(json: any): CreateEmployeeRequest {
    return CreateEmployeeRequestFromJSONTyped(json, false);
}

export function CreateEmployeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'emailAddress': json['emailAddress'],
        'countryCode': json['countryCode'],
        'localPhoneNumber': json['localPhoneNumber'],
        'age': json['age'],
        'zipCode': json['zipCode'],
        'placeOfResidence': json['placeOfResidence'],
        'campaignCode': json['campaignCode'],
    };
}

export function CreateEmployeeRequestToJSON(value?: CreateEmployeeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fullName': value.fullName,
        'emailAddress': value.emailAddress,
        'countryCode': value.countryCode,
        'localPhoneNumber': value.localPhoneNumber,
        'age': value.age,
        'zipCode': value.zipCode,
        'placeOfResidence': value.placeOfResidence,
        'campaignCode': value.campaignCode,
    };
}

